export enum BacnetServicesSupported
{
    /* Alarm and Event Services */
    ACKNOWLEDGE_ALARM = 0,
    CONFIRMED_COV_NOTIFICATION = 1,
    CONFIRMED_EVENT_NOTIFICATION = 2,
    GET_ALARM_SUMMARY = 3,
    GET_ENROLLMENT_SUMMARY = 4,
    GET_EVENT_INFORMATION = 39,
    SUBSCRIBE_COV = 5,
    SUBSCRIBE_COV_PROPERTY = 38,
    LIFE_SAFETY_OPERATION = 37,
    /* File Access Services */
    ATOMIC_READ_FILE = 6,
    ATOMIC_WRITE_FILE = 7,
    /* Object Access Services */
    ADD_LIST_ELEMENT = 8,
    REMOVE_LIST_ELEMENT = 9,
    CREATE_OBJECT = 10,
    DELETE_OBJECT = 11,
    READ_PROPERTY = 12,
    READ_PROP_CONDITIONAL = 13,
    READ_PROP_MULTIPLE = 14,
    READ_RANGE = 35,
    WRITE_PROPERTY = 15,
    WRITE_PROP_MULTIPLE = 16,
    WRITE_GROUP = 40,
    /* Remote Device Management Services */
    DEVICE_COMMUNICATION_CONTROL = 17,
    PRIVATE_TRANSFER = 18,
    TEXT_MESSAGE = 19,
    REINITIALIZE_DEVICE = 20,
    /* Virtual Terminal Services */
    VT_OPEN = 21,
    VT_CLOSE = 22,
    VT_DATA = 23,
    /* Security Services */
    AUTHENTICATE = 24,
    REQUEST_KEY = 25,
    I_AM = 26,
    I_HAVE = 27,
    UNCONFIRMED_COV_NOTIFICATION = 28,
    UNCONFIRMED_EVENT_NOTIFICATION = 29,
    UNCONFIRMED_PRIVATE_TRANSFER = 30,
    UNCONFIRMED_TEXT_MESSAGE = 31,
    TIME_SYNCHRONIZATION = 32,
    UTC_TIME_SYNCHRONIZATION = 36,
    WHO_HAS = 33,
    WHO_IS = 34,
    /* Other services to be added as they are defined. */
    /* All values in this production are reserved */
    /* for definition by ASHRAE. */
    MAX_BACNET_SERVICES_SUPPORTED = 41
}